"use client";

import { useQuery } from "@tanstack/react-query";

export type UsageData = {
  messageCount: number;
  limit: number;
  remaining: number;
  monthYear: string;
};

/**
 * Fetch usage data for the authenticated user.
 * The server determines the user from the auth session - no userId is sent.
 * @param userId - Only used to determine if the query should be enabled (user is logged in)
 */
export function useUsage(userId: string | null) {
  return useQuery<UsageData>({
    queryKey: ["usage", userId],
    queryFn: async () => {
      if (!userId) throw new Error("No user ID");
      
      // Don't pass userId - server uses authenticated session for security
      const res = await fetch("/api/usage");
      if (!res.ok) {
        if (res.status === 401) {
          throw new Error("Authentication required");
        }
        throw new Error("Failed to fetch usage");
      }
      return res.json();
    },
    enabled: !!userId,
    staleTime: 10 * 1000, // Consider data fresh for 10 seconds
    refetchInterval: 30 * 1000, // Refetch every 30 seconds
  });
}

